import React from 'react';
import Header from './Header';
import Footer from './Footer';
import SEO from './SEO';
import { getBreadcrumbSchema } from '../utils/structuredData';
import { useTranslation } from '../contexts/TranslationContext';

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  
  const breadcrumbSchema = getBreadcrumbSchema([
    { name: "Home", url: `${window.location.origin}/` },
    { name: "Privacy Policy", url: `${window.location.origin}/privacy-policy` }
  ]);

  return (
    <div>
      <SEO
        title="Privacy Policy - Out of Box | Data Protection & Privacy"
        description="Learn about Out of Box's privacy policy, data protection practices, and how we handle your personal information for our company registration services."
        keywords="privacy policy, data protection, GDPR, privacy rights, data security, Out of Box privacy"
        structuredData={breadcrumbSchema}
        type="article"
      />
      <Header />
      <section className="legal-page">
        <div className="container">
          <div className="legal-header">
            <h1>{t('privacy-policy-title')}</h1>
            <p className="last-updated">{t('privacy-last-updated')}</p>
          </div>
          
          <div className="legal-content">
            <div className="legal-section">
              <h2>{t('privacy-intro-title')}</h2>
              <p>{t('privacy-intro-text')}</p>
            </div>

            <div className="legal-section">
              <h2>{t('privacy-collect-title')}</h2>
              <p>{t('privacy-collect-text')}</p>
              <ul>
                <li><strong>{t('privacy-collect-contact')}</strong></li>
                <li><strong>{t('privacy-collect-business')}</strong></li>
                <li><strong>{t('privacy-collect-analytics')}</strong></li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>{t('privacy-use-title')}</h2>
              <p>{t('privacy-use-text')}</p>
              <ul>
                <li>{t('privacy-use-respond')}</li>
                <li>{t('privacy-use-quotes')}</li>
                <li>{t('privacy-use-communicate')}</li>
                <li>{t('privacy-use-improve')}</li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>{t('privacy-sharing-title')}</h2>
              <p>{t('privacy-sharing-text')}</p>
            </div>

            <div className="legal-section">
              <h2>{t('privacy-security-title')}</h2>
              <p>{t('privacy-security-text')}</p>
            </div>

            <div className="legal-section">
              <h2>{t('privacy-cookies-title')}</h2>
              <p>{t('privacy-cookies-text')}</p>
            </div>

            <div className="legal-section">
              <h2>{t('privacy-rights-title')}</h2>
              <p>{t('privacy-rights-text')}</p>
              <ul>
                <li>{t('privacy-rights-know')}</li>
                <li>{t('privacy-rights-update')}</li>
                <li>{t('privacy-rights-contact')}</li>
              </ul>
            </div>

            <div className="legal-section">
              <h2>{t('privacy-updates-title')}</h2>
              <p>{t('privacy-updates-text')}</p>
            </div>

            <div className="legal-section">
              <h2>{t('privacy-contact-title')}</h2>
              <p>{t('privacy-contact-text')}</p>
              <div className="contact-info">
                <p><strong>{t('privacy-contact-email')}</strong></p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy; 